<template>
  <div class="copy_ope"
  >
    <Poptip
      v-model="visible"
      width="300"
      trigger="click"
      placement="right-start"
      :transfer="true"
      popper-class="popper-copy-info-class"
      @on-popper-show="showPop"
    >
      <span class="ope">复制信息</span>
      <div slot="content">
        <i class="iconfont iconchajianguanbi" @click="visible=false"></i>
        <div style="height: 24px; text-align: right; height: 150px;">
          <copycard :clipboardText="clipboardText"></copycard>
        </div>
      </div>
    </Poptip>
  </div>
</template>
<script>
import copycard from '@/components/clipboard/copycard.vue'
export default {
  name: 'copyope',
  components: {
    copycard
  },
  data() {
    return {
      visible: false
    }
  },
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  computed: {
    clipboardText() {
      return '' +
        '工具名称: ' + this.rowData.tool_name_text + '\n' +
        '时间: 1年 \n' +
        '卡号: ' + this.rowData.card_no + ' \n' +
        '卡密: ' + this.rowData.card_pwd + ' \n'
    }
  },
  mounted() {
    // 滚动监听，关闭复制信息弹窗
    document.querySelector('.v-table-body').addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.visible = false
    },
    // 复制信息弹窗底部为止重新计算
    showPop() {
      const bodyHeight = document.body.offsetHeight
      const popPosition = document.querySelectorAll('.popper-copy-info-class')[this.index].style.top.split('px')[0] // 当前浮窗top值
      if (bodyHeight - popPosition < 190) {
        setTimeout(() => {
          this.$nextTick(() => {
            const topNum = bodyHeight - 186
            document.getElementsByClassName('popper-copy-info-class')[this.index].style.top = topNum + 'px' // 设置新top值
          }, 200)
        }, 0)
      }
    }
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.ope {
  color: $blue;
  cursor: pointer;
}
.iconchajianguanbi {
  position: absolute;
  right: 18px;
  top: 5px;
  font-size: 14px;
  cursor: pointer;
}
</style>
